import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useState } from 'react';
import ReactSelect from 'react-select';
import theme from '../../../styles/theme';
import AppText from '../../typography/app_text';
export function Select({ isDisabled, onSelect, onFocus, onBlur, placeholder, initialValue, options, size = 'large', border = false, isSearchable = true, externallyControlledOption, setExternallyControlledOption, ...props }) {
    const [locallyControlledOption, setLocallyControlledOption] = useState(initialValue);
    const optionToUse = externallyControlledOption ?? locallyControlledOption;
    const setOptionToUse = setExternallyControlledOption ?? setLocallyControlledOption;
    const onSelectOption = useCallback((option) => {
        setOptionToUse(option);
        if (onSelect) {
            onSelect(option);
        }
    }, [onSelect, setOptionToUse]);
    const selectedOption = options.find((option) => option.label === optionToUse?.label);
    const formatOptionLabel = ({ label }) => _jsx(AppText, { children: label });
    return (_jsx(ReactSelect, { isDisabled: isDisabled, classNamePrefix: 'ui-select', value: selectedOption, placeholder: _jsx(AppText, { color: "grey40", children: placeholder }), onFocus: onFocus, onBlur: onBlur, onChange: (option) => onSelectOption(option), formatOptionLabel: formatOptionLabel, components: {
            IndicatorSeparator: () => null,
        }, styles: {
            container: provided => ({
                ...provided,
                fontSize: theme.text.size[size],
            }),
            control: (provided, { isFocused }) => ({
                ...provided,
                boxShadow: 'none',
                height: size === 'large' ? 40 : 30,
                borderWidth: !border ? '0px' : isFocused ? '2px' : '1px',
                borderRadius: '2px',
                borderColor: isFocused ? theme.colors.borderBlue : theme.colors.grey90,
                background: theme.colors.white,
            }),
            singleValue: provided => ({
                ...provided,
                width: '100%',
                textAlign: 'left',
                paddingLeft: theme.space[2],
                overflow: 'visible',
            }),
            placeholder: provided => ({
                ...provided,
                width: '100%',
                textAlign: 'left',
                paddingLeft: theme.space[2],
                overflow: 'visible',
            }),
            menu: provided => ({
                ...provided,
                marginTop: '0px',
                borderRadius: '2px',
                boxShadow: theme.shadow.large,
            }),
            option: (provided, { isFocused, isSelected }) => ({
                ...provided,
                // Currently the select auto-focuses on the first item in the menu. This is fixed in https://github.com/JedWatson/react-select/pull/3792 but hasn't been released yet.
                backgroundColor: isSelected
                    ? theme.colors.grey05
                    : isFocused
                        ? theme.colors.grey10
                        : undefined,
            }),
        }, autoFocus: false, options: options, isSearchable: isSearchable, ...props }));
}
//# sourceMappingURL=select.js.map